import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import { stat } from 'fs';

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    albums: [],
    goods: {},
    promos: [],
    cart: {}
  },
  mutations: {
    updateGoods(state, {data,cart}){
      state.cart = cart
      state.albums = data.albums
      state.goods = data.goods
      state.promos = data.promos
    },
    updateCart(state, cart){
      localStorage.setItem('cart', JSON.stringify(cart))
      state.cart = Object.assign({}, cart)
    }
  },
  actions: {
    async getAll({commit}){
      const body = await axios('https://api.idako.ru/')

      // Get cart from localstorage
      const localStorageCart = localStorage.getItem('cart')
      var cart = {}
      if (localStorageCart){
        cart = JSON.parse(localStorageCart)
      }
      // And clear cart from unavailable goods
      for (var goodId in cart){
        if (!body.data.goods.hasOwnProperty(goodId)){
          delete cart[goodId]
        }
      }
      localStorage.setItem('cart', JSON.stringify(cart))
      //
      
      commit('updateGoods',{'data':body.data,cart})
    },
    addToCart({state,commit}, {id, type}){
      var tempCart = Object.assign({}, state.cart)
      var count = 0
      if (type){
        count = 1
      }else{
        count = -1
      }
      if (!tempCart.hasOwnProperty(id)){
        tempCart[id] = 0
      }
      tempCart[id] = tempCart[id] + count
      if (tempCart[id]<=0) { delete tempCart[id]}
      commit('updateCart',tempCart)
    },
    madeOrder({state,commit}, ){
      commit('updateCart',{})
    }
  },
  getters: {
    getLoad (state){
      if (state.albums.length > 0 ){
        return true
      }else{
        return false
      }
    },
    getAlbumsAndGoods(state){
      var albumsAndGoods = []
      for (var album of state.albums){
        var goods = []
        for (var goodId of album.goods){
          var temp = Object.assign({}, state.goods[goodId])
          if (state.cart[goodId]){
            temp.cart = state.cart[goodId]
          }else{
            temp.cart = 0
          }
          goods.push(temp)
        }
        albumsAndGoods.push({'id':album.id,'title':album.title, 'titleEn':album.titleEn ,goods})
      }
      return albumsAndGoods
    },
    getGoods(state){
      return state.goods
    },
    getAlbums(state){
      return state.albums
    },
    getGoods(state){
      return state.goods
    },
    getPromos(state){
      return state.promos
    },
    getPromosCount(state){
      if (state.promos.length > 1){
        return true
      }else {
        return false
      }
    },
    getCartCount(state){
      var cartCount = 0
      for (var goodId in state.cart){
        cartCount = cartCount + state.cart[goodId]
      }
      return cartCount
    },
    getCartCountPrice(state){
      var cartCountPrice = 0
      for (var goodId in state.cart){
        cartCountPrice = cartCountPrice + state.goods[goodId].price*state.cart[goodId]
      }
      return cartCountPrice
    },
    getCartAndGoods(state){
      var cartAndGoods = []
      for (var goodId in state.cart){
        var temp = Object.assign({}, state.goods[goodId])
        temp.cart = state.cart[goodId]
        cartAndGoods.push(temp) 
      }
      return cartAndGoods
    },
  }
})
